import { Communicate } from '../generated/Communicate';
import { Student } from '../generated/Student';
import { SupportPlanDTO } from './SupportPlanDTO';

export class UserSupportPlanDTO {
  student: Student = new Student();
  communicate: Communicate = new Communicate();

  plans: SupportPlanDTO[] = [];

  courseList: string[] = [];
}
